<section class="footer">
  <div class="container">
    <div class="footer-grid">
      <div class="column">
        <label>{{ translate("footer.salesEnquiries") }}</label>
        <a [href]="'mailto:' + infoEmail" class="margin-link">{{
          infoEmail
        }}</a>

        <label>{{ translate("footer.generalEnquiries") }}</label>
        <a [href]="'mailto:' + officeEmail" class="margin-link">{{
          officeEmail
        }}</a>

        <label>{{ translate("footer.followUs") }}</label>
        <div class="socials">
          <a href="#" target="_blank" class="icon">
            <img
              src="assets/icons/instagram_icon.svg"
              alt="{{ translate('footer.social.instagram') }}"
            />
          </a>
          <a href="#" target="_blank" class="icon">
            <img
              src="assets/icons/linkedin_icon.svg"
              alt="{{ translate('footer.social.linkedin') }}"
            />
          </a>
          <a href="#" target="_blank" class="icon">
            <img
              src="assets/icons/facebook_icon.svg"
              alt="{{ translate('footer.social.facebook') }}"
            />
          </a>
        </div>
      </div>

      <div class="column">
        <label>{{ translate("footer.office") }}</label>
        <a
          href="https://maps.google.com/?q=Temes u. 18, 3528 Miskolc, HUNGARY"
          target="_blank"
          class="margin-link"
        >
          {{ translate("contact.address.full") }}
        </a>

        <label>{{ translate("footer.factory") }}</label>
        <a
          href="https://maps.google.com/?q=Temes u. 18, 3528 Miskolc, HUNGARY"
          target="_blank"
          class="margin-link"
          id="responsive-link"
        >
          {{ translate("contact.address.full") }}
        </a>
      </div>

      <div class="column">
        <label>{{ translate("footer.pages") }}</label>
        <div class="footer-links">
          <a routerLink="/">{{ translate("footer.homePage") }}</a>
          <a routerLink="/homes">{{ translate("nav.mobileHomes") }}</a>
          <a routerLink="/products">{{ translate("nav.products") }}</a>
          <a routerLink="/about">{{ translate("nav.about") }}</a>
          <a routerLink="/contact">{{ translate("nav.contact") }}</a>
          <a routerLink="/blog">{{ translate("nav.blog") }}</a>
        </div>
      </div>

      <div class="column">
        <label>{{ translate("footer.products") }}</label>
        <div class="footer-links">
          <a routerLink="/homes">{{ translate("nav.mobileHomes") }}</a>
          <a routerLink="/products/garages">{{
            translate("footer.garages")
          }}</a>
          <a routerLink="/products/carports">{{
            translate("footer.carports")
          }}</a>
          <a routerLink="/products/containers">{{
            translate("footer.containers")
          }}</a>
          <a routerLink="/products/outdoor-kitchens">{{
            translate("footer.kitchens")
          }}</a>
          <a routerLink="/products/garbage-bins">{{
            translate("footer.garbageBins")
          }}</a>
        </div>
      </div>
    </div>

    <div class="footer-divider"></div>

    <div class="bottom-links">
      <a>{{
        translate("footer.copyright").replace("{year}", currentYear.toString())
      }}</a>
      <div class="legal">
        <a routerLink="/sitemap">{{ translate("footer.sitemap") }}</a>
        <a (click)="openPrivacyModal()" class="modal-link">{{ translate("footer.privacy") }}</a>
        <a (click)="openTermsModal()" class="modal-link">{{ translate("footer.terms") }}</a>
        <a (click)="openCookieModal()" class="modal-link">{{ translate("footer.cookies") || "Cookie Policy" }}</a>
      </div>
      
      <!-- Privacy Policy Modal -->
      <app-legal-modal 
        *ngIf="showPrivacyModal" 
        [title]="translate('footer.privacy')" 
        [content]="privacyContent" 
        (closeModal)="closeModals()">
      </app-legal-modal>
      
      <!-- Terms of Service Modal -->
      <app-legal-modal 
        *ngIf="showTermsModal" 
        [title]="translate('footer.terms')" 
        [content]="termsContent" 
        (closeModal)="closeModals()">
      </app-legal-modal>
      
      <!-- Cookie Policy Modal -->
      <app-legal-modal 
        *ngIf="showCookieModal" 
        [title]="translate('footer.cookies') || 'Cookie Policy'" 
        [content]="cookieContent" 
        (closeModal)="closeModals()">
      </app-legal-modal>
    </div>
  </div>
</section>
